export default __webpack_public_path__ + "static/media/modelingImg.2665f0a9.jpg";